module.exports = __webpack_public_path__ + "static/media/icono_campana_entrada.a917ece8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/icono_campana_entrada.svg
// module id = 1755
// module chunks = 0